var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 23,
    viewBox: "0 0 36 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4416 14.8229C19.4416 15.0999 19.4581 15.3442 19.4746 15.5722C19.87 19.7422 23.4124 23 27.7291 23C32.2929 23 36 19.335 36 14.8229C36 10.4901 32.5895 6.95538 28.2728 6.66218C27.8279 3.12748 29.7391 1.00991 30.9748 -0.0162907C27.1854 0.4398 20.0018 5.92918 19.4911 13.9433C19.4746 14.2365 19.4416 14.5297 19.4416 14.8229Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.90735e-06 14.8229C-1.90735e-06 15.0999 0.0164738 15.3442 0.0329494 15.5722C0.428373 19.7422 3.97071 23 8.28741 23C12.8513 23 16.5583 19.335 16.5583 14.8229C16.5583 10.4901 13.1478 6.95538 8.83112 6.66218C8.38627 3.12748 10.2975 1.00991 11.5332 -0.0162907C7.7437 0.4398 0.560183 5.92918 0.049427 13.9433C0.0164757 14.2365 -1.90735e-06 14.5297 -1.90735e-06 14.8229Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColon);
export default __webpack_public_path__ + "static/media/colon.2efa077ca13130eb1d5a4a4143d6bbd2.svg";
export { ForwardRef as ReactComponent };